export default __webpack_public_path__ + "static/media/sms.eb39e8bf.jpg";